import t from "react";
import { SharedLandingCtx as e } from "./context.js";
function o() {
  return t.useContext(e);
}
export {
  o as useSharedLanding
};
//# sourceMappingURL=useSharedLanding.js.map
